<template>
<div>
    <div v-for="battery in batteries" :key="battery.deviceId">
        <div v-if="battery.device" class="row">
            <!-- Control mode -->
            <div class="col-12 col-sm-12 col-md-4">
                <div class="card shadow mb-4">
                    <div class="card-body">
                        <h6 v-if="battery.name || battery.name != ''" class="d-inline mr-1"><span class="badge badge-dark">{{ battery.name }} </span></h6>
                        <label class="control-label">
                            <span> {{ $t('Current_mode') }}:</span> 
                        </label>
                        <span class="h6 mb-0 font-weight-bold text-gray-800"> 
                            <span v-if="battery.last_sample.mode == 'ExternalControl' && battery.device.mode == 'manual'"> {{ $t('Manual') }}</span>
                            <span v-else-if="battery.device.mode == 'idle'"> {{ $t('Idle') }}</span>
                            <span v-else-if="battery.last_sample.mode != 'ExternalControl' || battery.device.mode == 'hbf+voltage-control' || battery.device.mode == 'voltage-control' || (battery.device.mode != 'manual' && battery.device.mode != 'idle' && battery.last_sample.state != 'Idling')"> {{ $t('Automatic') }}</span>
                            <span v-if="battery.device.mode!='manual' && battery.device.mode!='idle'">
                                (<span v-show="battery.device.mode == 'voltage-control'">{{ $t('Voltage_control') }}</span>
                                <span v-show="battery.device.mode == 'hbf+voltage-control'">{{ $t('HBF_Voltage_control') }}</span>
                                <span v-show="battery.device.mode == 'greedy'">Greedy</span>
                                <span v-show="battery.device.mode == 'precharge+greedy'"> Precharge + Greedy {{ battery.device.precharge }}%</span>)
                            </span>
                        </span>
                        <hr>
                        <div class="row"> 
                            <div class="col-12 mt-2">
                                <label class="control-label">
                                    <span>{{ $t('Select_control_mode') }}:</span>
                                </label>
                                <select v-model="selected_mode" class="form-control mb-1">
                                    <option :value="''">-</option>
                                    <option :value="'idle'">{{ $t('Idle') }}</option>
                                    <option v-if="selected_producerId == '5ad5dd1177a88f0656ff4077'" :value="'voltage-control'">{{ $t('Automatic') }} ({{ $t('Voltage_control') }})</option>
                                    <option v-if="selected_producerId == '5ad5dd1177a88f0656ff4077'" :value="'hbf+voltage-control'">{{ $t('Automatic') }} ({{ $t('HBF_Voltage_control') }})</option>
                                    <option v-if="selected_producerId != '5ad5dd1177a88f0656ff4077'" :value="'greedy'">{{ $t('Automatic') }} (Greedy)</option>
                                    <option v-if="selected_producerId != '5ad5dd1177a88f0656ff4077'" :value="'precharge+greedy'">{{ $t('Automatic') }}  (Precharge + Greedy)</option>
                                    <option :value="'manual'">Manual</option>
                                </select>
                            </div>
                            <div v-show="selected_mode=='precharge+greedy'" class="col-3">
                                <label for="ex2">Percentagem:</label>
                                <input v-model="selected_precharge" class="form-control" id="ex2" type="text">
                            </div>
                             <!--<div class="col-12 col-md-12 text-center mb-2">
                                <div class="dropdown">
                                    <button 
                                    class="btn btn-block dropdown-toggle" 
                                    type="button" id="dropdownMenuButton" 
                                    :class="{'btn-primary': (battery.last_sample.mode != 'ExternalControl' || battery.device.mode != 'manual' ), 'btn-light': (battery.last_sample.mode == 'ExternalControl' && battery.device.mode == 'manual') }" 
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Automático <span v-show="battery.last_sample.mode != 'ExternalControl'">({{ battery.last_sample.mode }})</span>
                                    </button>
                                    <div class="dropdown-menu" style="width:100%; cursor:pointer;" aria-labelledby="dropdownMenuButton">
                                         <a class="dropdown-item" :class="{ active: battery.last_sample.mode == 'SelfConsumption' }" @click="change_control_mode(battery, 'SelfConsumption')">Self-consumption</a>
                                        <a class="dropdown-item" :class="{ active: battery.last_sample.mode == 'LoadMatching' }" @click="change_control_mode(battery, 'LoadMatching')">Load Matching</a>
                                        <a class="dropdown-item" :class="{ active: battery.last_sample.mode == 'GridSupport' }" @click="change_control_mode(battery, 'GridSupport')">Grid Support</a>
                                        <a class="dropdown-item" :class="{ active: battery.last_sample.mode == 'ExternalControl' && battery.device.mode == 'greedy' }" @click="change_control_mode(battery, 'Greedy')">Greedy</a>
                                        <a class="dropdown-item" :class="{ active: battery.last_sample.mode == 'ExternalControl' && battery.device.mode == 'precharge+greedy' }" @click="change_control_mode(battery, 'Precharge+Greedy')">Precharge+Greedy</a>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-12 col-md-12 text-center mb-2">
                                <button 
                                    type="button" 
                                    :class="{'btn-primary': (battery.last_sample.mode == 'ExternalControl' && battery.device.mode == 'manual'), 'btn-light': (battery.last_sample.mode != 'ExternalControl' || battery.device.mode != 'manual' ) }" 
                                    @click="change_control_mode(battery, 'manual')" 
                                    class="btn btn-block">
                                    {{ $t('Manual') }}
                                </button>
                            </div>-->
                            <div class="col-12 mt-2 text-center">
                                <button @click="change_control_mode(battery)" class="btn btn-primary">{{ $t('Set_control_mode') }}</button>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>

            <!-- Active and Reactive power setpoints -->
            <div class="col-12 col-sm-12 col-md-8">
                <div class="card shadow mb-4">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6 border-left">
                                <div class="row align-items-center">
                                    <div class="col-12 col-md-8">
                                        <span class="font-weight-bold">{{ $t('Active_power') }}</span>
                                        <p>Setpoint {{ $t('in_use') }}:</p>
                                        <div v-if="battery.current_setpoint && battery.current_setpoint.active_power && battery.current_setpoint.active_power.start_setpoint && battery.current_setpoint.active_power.start_setpoint.active_power != null">
                                            <p class="h5 mb-0 font-weight-bold text-gray-800"> 
                                                {{ battery.current_setpoint.active_power.start_setpoint.active_power.toFixed(2).replace(".", ",") }} kW
                                            </p>
                                            <span> {{ $t('From') }}: {{ getDate(battery.current_setpoint.active_power.start_setpoint.setpoint_timestamp) }}</span> <!-- {{ getDate(new Date().toJSON()) }} --> 
                                            <span v-if="battery.current_setpoint.active_power.end_setpoint" class="d-block"> {{ $t('To') }}: {{ getDate(battery.current_setpoint.active_power.end_setpoint.setpoint_timestamp) }}</span>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger"> {{ $t("No_setpoints") }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 d-md-block text-center">
                                        <i class="fas fa-fw fa-bolt fa-3x mr-auto" style="height:62px;"></i>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-12 col-md-6 border-left">
                                <div class="row align-items-center">
                                    <div class="col-12 col-md-8">
                                        <span class="font-weight-bold">{{ $t('Reactive_power') }}</span>
                                        <p>Setpoint {{ $t('in_use') }}:</p>
                                        <div v-if="battery.current_setpoint && battery.current_setpoint.reactive_power && battery.current_setpoint.reactive_power.start_setpoint && battery.current_setpoint.reactive_power.start_setpoint.reactive_power != null">
                                            <p class="h5 mb-0 font-weight-bold text-gray-800"> 
                                                {{ battery.current_setpoint.reactive_power.start_setpoint.reactive_power.toFixed(2).replace(".", ",") }} kVAr
                                            </p>
                                            <span> {{ $t('From') }}: {{ getDate(battery.current_setpoint.reactive_power.start_setpoint.setpoint_timestamp) }} <!-- {{ getDate(new Date().toJSON()) }} --> </span>
                                            <span v-if="battery.current_setpoint.reactive_power.end_setpoint" class="d-block"> {{ $t('To') }}: {{ getDate(battery.current_setpoint.reactive_power.end_setpoint.setpoint_timestamp) }}</span>
                                        </div>
                                        <div v-else>
                                            <p class="text-danger"> {{ $t("No_setpoints") }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 d-md-block text-center">
                                        <i class="fas fa-fw fa-bolt fa-3x" style="height:62px;"></i>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-12 mt-1 text-center">
                                <hr>
                                <!-- <button @click="open_modal(battery)">asdsad</button> -->
                                <button @click="open_modal(battery)" :disabled="battery.device.mode!='manual' || battery.last_sample.mode !='ExternalControl'" class="btn btn-primary">{{ $t('Set') }} setpoints</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    </div>

    <!-- The Modal -->
    <div class="modal" id="myModal">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" style="height: 90vh">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> {{ $t('Send')}} setpoints</h4>
                    <button type="button" class="close" style="color:white" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body text-center">
                    <p> {{ $t('Click_button_below_to_add_setpoints') }}. </p>
                    <div v-for="(setpoint,index) in setpoints" :key="index">
                        <div v-if="!setpoint.removed">
                            <div class="text-right"><button @click="removeSetpoint(index)" class="btn btn-sm btn-light">X</button></div>
                            <div class="input-group mt-3 mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">{{ $t("Start_date") }}</span>
                                </div>
                                <input type="text" :id="'datetime-picker-start-'+index" value="" class="form-control" aria-label="date-start" aria-describedby="basic-addon1">
                            </div>
                            <div class="input-group mt-3 mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">{{ $t("End_date") }}</span>
                                </div>
                                <input type="text" :id="'datetime-picker-end-'+index" value="" class="form-control" aria-label="date-start" aria-describedby="basic-addon1">
                            </div>
                            <div class="input-group mt-3 mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon2">{{ $t("Active_power") }} ({{ 'kW' }})</span>
                                </div>
                                <input v-model="setpoint.active_power" type="text" class="form-control" aria-label="power" aria-describedby="basic-addon2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon3">{{ $t("Reactive_power") }} ({{ 'kVAr' }})</span>
                                </div>
                                <input :placeholder="$t('Not_available')" disabled v-model="setpoint.reactive_power" type="text" class="form-control" aria-label="power" aria-describedby="basic-addon3">
                            </div>
                            <hr>
                        </div>
                    </div>
                    <span style="font-size: 9pt">Valores positivos: carrega | Valores negativos: descarrega </span>
                </div>
                <div class="modal-footer">
                    <button @click="add_setpoint" class="btn btn-sm btn-info mr-auto">Adicionar setpoint</button>
                    <button @click="send" class="btn btn-sm btn-primary">{{ $t("Send") }}</button>
                    <button @click="closeModal" class="btn btn-sm btn-light" data-dismiss="modal">{{ $t("Cancel") }}</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: "SubstationControl",
    data() {
        return {
            batteries: [],
            modal_type: null,
            selected_battery: {},
            selected_mode: "",
            selected_precharge: "",
            setpoints: [],
            datetime_picker_options: null,
        }
    },
    mounted() {
      this.datetime_picker_options = {
        format: 'DD-MM-YYYY HH:mm:[00]',
        viewMode: 'days',
        sideBySide: true,
        ignoreReadonly: true,
        locale: moment.locale(this.current_lang, {
          week: { dow: 1 }
        }),
        widgetPositioning:{
            horizontal: 'auto',
            vertical: 'bottom'
        },
        useCurrent: false,
        toolbarPlacement:'top',
        debug: false,
        showClear:true,
        showClose:true,
        icons: {
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          up: "fas fa-chevron-up",
          down: "fas fa-chevron-down",
          time: "fas fa-clock",
          date: 'fas fa-calendar',
          clear: 'fas fa-trash',
          close: 'fas fa-window-close'
        }
      }

    $('#myModal').on('hidden.bs.modal', function(){
        //$(`#datetime-picker`).data("DateTimePicker").clear()
        this.setpoints = []
      })
    },
    methods: {
        change_control_mode: function(battery, mode){
            _paq.push(['trackEvent', this.current_page, 'Alterar modo de controlo', mode])
            /* this.$store.dispatch('setBattControlMode', {
                deviceId: battery.device.xolta.id,
                mode
            }).then(response => {
                if (response.length == 0) return
                battery.last_sample.mode = response[0].data
                let last_setpoint = { utcTime: null }
                for (let key in response[1].data.setPoints) {
                    if (new Date(last_setpoint.utcTime).valueOf() < new Date(response[1].data.setPoints[key].utcTime).valueOf()) 
                        last_setpoint = response[1].data.setPoints[key]
                }
                //console.log(last_setpoint)

                //battery.last_setpoints = response[1].setPoints
            }).catch(e => { return }) */

            if (this.selected_mode == "") {
                this.$noty.error("<strong>Erro!</strong> Modo de controlo não selecionado.", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            }
            if ((this.selected_mode == "precharge+greedy" && (!/^\d+$/.test(this.selected_precharge) || this.selected_precharge == "" || parseFloat(this.selected_precharge) < 0 || parseFloat(this.selected_precharge) > 100))) {
                this.$noty.error("<strong>Erro!</strong> A percentagem deve ser entre 0 e 100.", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            } 
            
            this.$store.dispatch('setBattControlMode', {
                deviceId: battery.device.deviceId || null,
                mode: this.selected_mode,
                precharge: this.selected_precharge == '' ? null : this.selected_precharge
            }).then(response => {
                battery.device.mode = this.selected_mode
                battery.device.precharge = this.selected_precharge
                this.selected_precharge = ""

                this.$noty.success("<i class='fas fa-check'></i> Pedido efetuado com sucesso.", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            }).catch(e => {
                this.$noty.error(e.response.data.error, {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            })
            
        },
        getDate: function(datetime) {
            return moment.tz(datetime, this.timezone).format("YYYY-MM-DD HH:mm:ss")
        },
        open_modal: function(battery, type) {
            //_paq.push(['trackEvent', this.current_page, 'Ver Instruções', "EV_"+car.station.ev.number])
            this.modal_type = type
            this.setpoints = []
            this.add_setpoint()
            this.selected_battery = battery
            $("#myModal").modal('show')
        },
        closeModal: function(){
            $("#myModal").modal('hide')
            this.selected_battery = {}
            this.setpoints = []
        }, 
        add_setpoint: function(){
            this.setpoints.push({ datetime: null, active_power: null, reactive_power: null })
            this.$nextTick( () => {
                $(`#datetime-picker-start-${this.setpoints.length-1}`).datetimepicker(this.datetime_picker_options)
                $(`#datetime-picker-start-${this.setpoints.length-1}`).data("DateTimePicker").minDate(new Date())
                $(`#datetime-picker-start-${this.setpoints.length-1}`).data("DateTimePicker").date(new Date())
                $(`#datetime-picker-end-${this.setpoints.length-1}`).datetimepicker(this.datetime_picker_options)
                $(`#datetime-picker-end-${this.setpoints.length-1}`).data("DateTimePicker").minDate(new Date())
                //$(`#datetime-picker-end-${this.setpoints.length-1}`).data("DateTimePicker").date(new Date())
            })
        },
        removeSetpoint: function(i){
            this.$set(this.setpoints[i], "removed", true)
            $(`#datetime-picker-start-${i}`).data("DateTimePicker").destroy()
            $(`#datetime-picker-end-${i}`).data("DateTimePicker").destroy()
        },
        send: function(battery){
            _paq.push(['trackEvent', this.current_page, 'Enviar setpoint'])
            let empty_datetimes = false
            let setpoints = []
            this.setpoints.forEach((s, i) => {
                if (s.removed) return

                let start_datetime = $(`#datetime-picker-start-${i}`).data("DateTimePicker").date()
                let end_datetime = $(`#datetime-picker-end-${i}`).data("DateTimePicker").date()

                if (!start_datetime) {
                    empty_datetimes = true
                }
                else {
                    start_datetime = new Date(start_datetime).toJSON()
                }

                let setpoint = { datetime: start_datetime }

                let end_setpoint = null
                if (end_datetime) {
                    end_datetime = new Date(end_datetime).toJSON()
                    end_setpoint = {}
                    end_setpoint.datetime = end_datetime
                }
                
                
                if (s.active_power != null && s.active_power != "") {
                    setpoint.active_power = parseFloat(s.active_power.replace(",", "."))
                    if (end_setpoint) end_setpoint.active_power = 0
                }

                if (s.reactive_power != null && s.reactive_power != "") {
                    setpoint.reactive_power = parseFloat(s.reactive_power.replace(",", "."))
                    if (end_setpoint) end_setpoint.reactive_power = 0
                }

                setpoints.push(setpoint)
                if (end_setpoint) setpoints.push(end_setpoint)
            }) 
            setpoints = setpoints.filter(s => s.datetime != null && (s.active_power != null || s.reactive_power != null))

            if (empty_datetimes) {
                this.$noty.error("<strong>Erro!</strong> Existem setpoints sem data de início definida.", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            }

            if (!setpoints.length) {
                this.$noty.error("<strong>Erro!</strong> Não foram inseridos setpoints.", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                return
            }

            /* console.log(JSON.stringify(setpoints))
            return */

            this.$store.dispatch('sendBattSetpoints', { 
                deviceId: this.selected_battery.device.deviceId, //this.selected_battery.device.xolta.id, 
                setpoints 
            }).then(response => {
                this.$noty.success("<i class='fas fa-check'></i> Setpoints enviados com sucesso!", {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
                this.closeModal()
            }).catch(e => {
                this.$noty.error(e.response.data.error, {
                    killer: true,
                    timeout: 2000,
                    layout: "bottomRight",
                    theme: 'metroui',
                })
            })
        }
    }, 
    computed: {
        data: function(){
            const current_data = this.$store.getters.current_data
            if (!current_data.hasOwnProperty('batteries')) {
                current_data.batteries = []
                current_data.batteries.push({})
            }
            return current_data
        },
        current_page: function(){
            return this.$route.name
        }, 
        current_lang: function(){
            return this.$i18n.locale
        },
        timezone: function(){
            return this.$store.getters.timezone
        },
        selected_producerId: function() {
            return this.$store.getters.selected_producerId
        }
    },
    watch: {
        data: function(){
            this.batteries = []
            this.data.batteries.forEach(d => {
                //let setpoints = []
                /* if (d.last_setpoints && d.last_setpoints.length) { 
                    d.last_setpoints.forEach((s) => {
                        s.setpoints_datetime.forEach((d, i) => {
                            setpoints.push({ datetime: d, active_power: s.setpoints_power[i] })
                        })
                    })
                    setpoints.sort((a,b) => new Date(a.datetime.valueOf()) - new Date(b.datetime.valueOf()))
                    var current_setpoint = setpoints.filter(s => s.datetime)
                } */

                this.batteries.push({
                    name: d.name,
                    deviceId: d.deviceId || null,
                    last_sample: d.last_sample || {},
                    device: d.device,
                    current_setpoint: d.current_setpoint || {},
                    //last_setpoints: setpoints 
                })
            })

            //console.log(this.batteries)
        },
        current_lang: function(){
            this.datetime_picker_options = { 
                ...this.datetime_picker_options,
                locale: moment.locale(this.current_lang, {
                    week: { dow: 1 }
                })
            }
            $("#datetime-picker-start-0").data("DateTimePicker").options({
                locale: moment.locale(this.current_lang, {
                    week: { dow: 1 }
                })
            })
            $("#datetime-picker-end-0").data("DateTimePicker").options({
                locale: moment.locale(this.current_lang, {
                    week: { dow: 1 }
                })
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import '../assets/vendor/datetimepicker/css/bootstrap-datetimepicker.min.css'; 
@import '~vuejs-noty/dist/vuejs-noty.css';

.dropdown-item:active, .dropdown-item:hover, .dropdown-item.active {
    background-color: #4e73df!important;
    color: white!important
}

.modal input[type="text"]:read-only { 
    background-color: #ccc!important; 
}
</style>